export default new class Table {
  constructor() {
    this.init();
  }

  init() {
    const obTableList = $(document).find('table');

    obTableList.each(function(i, obElement) {
      $(obElement).wrapAll('<div class="table-mobile">');
    });
  }
}();
